@if (currentUser$ | async) {
  <div class="color-scale-container is-flex is-column gap-4 bg-grey-0 radius-8">
    @switch (selectedPintype()) {
      @case (PinType.TEMPERATURE) {
        <div class="is-flex is-justify-space-between gap-4">
          <div class="is-flex is-column gap-4">
            <div class="color-scale temperature"></div>
            <div class="scale is-flex is-justify-space-between text-12">
              @for (value of temperatureScale[unitSystem()]; track $index) {
                <div class="is-flex gap-2">
                  <app-text class="is-family-medium" [text]="value" />
                </div>
              }
            </div>
          </div>
          <div class="is-flex is-align-end">
            <app-text class="is-family-medium text-grey-70 text-12" unit [measureType]="EnumMeasureTypes.TEMPERATURE" />
          </div>
        </div>
      }

      @case (PinType.RAIN) {
        <div class="scale is-flex is-justify-space-evenly text-12">
          @for (value of rainScale.top; track $index) {
            <app-text class="is-family-medium" [text]="value | AsyncLang | async" />
          }
        </div>

        <div class="color-scale rain"></div>

        <div class="scale is-flex is-justify-space-between text-12">
          @for (value of rainScale.bottom; track $index) {
            <app-text class="is-family-medium" [text]="value | AsyncLang | async" />
          }
        </div>
      }

      @case (PinType.WIND) {
        <div class="is-flex is-justify-space-between gap-4">
          <div class="is-flex is-column gap-4">
            <div class="color-scale wind"></div>
            <div class="scale is-flex is-justify-space-between text-12">
              @for (value of windScale[windUnit()]; track $index) {
                <div class="is-flex gap-2">
                  <app-text class="is-family-medium">{{ value }}</app-text>
                </div>
              }
            </div>
          </div>
          <div class="is-flex is-align-end">
            <app-text
              class="is-family-medium text-grey-70 text-12"
              unit
              [measureType]="EnumMeasureTypes.WIND_STRENGTH"
            />
          </div>
        </div>
      }
    }
  </div>
}
